import { Component } from '@angular/core';
import { getMetadataArray, getNestedValue } from '../../util/table-v2.utils';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "@angular/common";
/**
 * @deprecated use v3 version of this component instead
 */
function MetadataValueRendererComponent_div_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(3, 1, ctx_r0.getMetadataArrayValue(), ctx_r0.config == null ? null : ctx_r0.config.format, ctx_r0.config == null ? null : ctx_r0.config.timezone, (tmp_3_0 = ctx_r0.config == null ? null : ctx_r0.config.locale) !== null && tmp_3_0 !== undefined ? tmp_3_0 : ctx_r0.translateService.currentLang), " ");
  }
}
function MetadataValueRendererComponent_div_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.getMetadataArrayValue());
  }
}
function MetadataValueRendererComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MetadataValueRendererComponent_div_0_ng_container_1_Template, 4, 6, "ng-container", 2)(2, MetadataValueRendererComponent_div_0_ng_template_2_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const otherMetadata_r2 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.metadataKey === "lastModified")("ngIfElse", otherMetadata_r2);
  }
}
export class MetadataValueRendererComponent {
  translateService;
  rowData;
  columnKey;
  config;
  getNestedValue = getNestedValue;
  constructor(translateService) {
    this.translateService = translateService;
  }
  getMetadataValue(metadata, key) {
    const found = metadata.find(m => m.name === key);
    return found?.value ? found.value : '';
  }
  getMetadataArrayValue() {
    if (!this.rowData || !this.columnKey || !this.config?.metadataKey) {
      return '';
    }
    const metadata = getMetadataArray(this.rowData, this.columnKey);
    if (!metadata) {
      return '';
    }
    return this.getMetadataValue(metadata, this.config.metadataKey);
  }
  static ɵfac = function MetadataValueRendererComponent_Factory(t) {
    return new (t || MetadataValueRendererComponent)(i0.ɵɵdirectiveInject(i1.TranslateService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MetadataValueRendererComponent,
    selectors: [["geaui-metadata-value-renderer"]],
    decls: 1,
    vars: 1,
    consts: [["otherMetadata", ""], [4, "ngIf"], [4, "ngIf", "ngIfElse"]],
    template: function MetadataValueRendererComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MetadataValueRendererComponent_div_0_Template, 4, 2, "div", 1);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.rowData);
      }
    },
    dependencies: [i2.NgIf, i2.DatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MetadataValueRendererComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-metadata-value-renderer',
      template: "<div *ngIf=\"rowData\">\n  <ng-container *ngIf=\"config.metadataKey === 'lastModified'; else otherMetadata\">\n    <span>\n      {{ getMetadataArrayValue() | date: config?.format : config?.timezone : config?.locale ?? translateService.currentLang }}\n    </span>\n  </ng-container>\n  <ng-template #otherMetadata>\n    <span>{{ getMetadataArrayValue() }}</span>\n  </ng-template>\n</div>\n"
    }]
  }], () => [{
    type: i1.TranslateService
  }], null);
})();
